<div class="breadcrumb">
  <span class="path" *ngFor="let path of displayPath"
    ><a [routerLink]="['../' + path.id]">{{ path.name }}</a
    ><span class="separator">/</span></span
  >
</div>
